export interface InvitationTokenPayload {
  companyId: string | null;
  companyName: string | null;
  email: string | null;
  expiresAt: Date | null;
}

const EMPTY_PAYLOAD: InvitationTokenPayload = {
  companyId: null,
  companyName: null,
  email: null,
  expiresAt: null,
};

// Klient czyta claimy bez weryfikacji podpisu wyłącznie dla UX (firma, adres,
// termin); podpis i ważność i tak sprawdza backend przy akceptacji.
export const readInvitationTokenPayload = (
  token: string,
): InvitationTokenPayload => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return EMPTY_PAYLOAD;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const claims = JSON.parse(atob(padded));
    return {
      companyId:
        typeof claims?.companyId === 'string' ? claims.companyId : null,
      // Starsze tokeny nie mają tego claimu.
      companyName:
        typeof claims?.companyName === 'string' ? claims.companyName : null,
      email: typeof claims?.sub === 'string' ? claims.sub : null,
      expiresAt:
        typeof claims?.exp === 'number' && Number.isFinite(claims.exp)
          ? new Date(claims.exp * 1000)
          : null,
    };
  } catch {
    return EMPTY_PAYLOAD;
  }
};

export const isInvitationExpired = (
  payload: InvitationTokenPayload,
  now: Date,
): boolean =>
  payload.expiresAt !== null && payload.expiresAt.getTime() < now.getTime();
